import React from "react";

// import "antd/dist/antd.less"; // or 'antd/dist/antd.less'
import "antd/dist/antd.min.css";

import { List, Space, Card, Row, Col } from "antd";

import { MessageOutlined, LikeOutlined, StarOutlined } from "@ant-design/icons";

import { CardImg, Container } from "react-bootstrap";

import "./readings.css";

import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { RenderSkeleton } from "./ReadingsSkeleton.jsx";

function getReflectionImage(readings) {
  if (readings[0]) {
    const { Reflection_Image } = readings[0];
    return Reflection_Image;
  }
  return "";
}

const IconText = ({ icon, text }) => (
  <Space>
    {React.createElement(icon)}
    {text}
  </Space>
);

const addNextLine = (str) => {
  let newStr = [];
  let strArr = str.split("R.");
  for (let s = 0; s < strArr.length - 1; s++) {
    newStr.push(strArr[s] + "R.");
  }
  return newStr;
};

const Readings = ({ readings }) => {
  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  React.useEffect(() => {
    document.addEventListener("contextmenu", handleContextMenu);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [readings]);
  return (
    <Container className="readings my-3">
      {readings === null ? (
        <RenderSkeleton />
      ) : (
        <Row gutter={16}>
          <Col
            span={16}
            style={{}}
            xs={24}
            md={16}
            className="margin-right: 1.5rem"
          >
            <div className="text-light">
              <List
                itemLayout="vertical"
                size="large"
                pagination={{
                  onChange: (page) => {
                    // console.log(page);
                  },
                  pageSize: 3,
                }}
                dataSource={readings}
                footer={
                  <div>
                    <b>Readings</b>
                  </div>
                }
                renderItem={(item) => (
                  <List.Item
                    key={item.Liturgical_Season}
                    className="text-start p-0"
                    actions={[
                      <IconText
                        icon={StarOutlined}
                        text="156"
                        key="list-vertical-star-o"
                      />,
                      <IconText
                        icon={LikeOutlined}
                        text="156"
                        key="list-vertical-like-o"
                      />,
                      <IconText
                        icon={MessageOutlined}
                        text="2"
                        key="list-vertical-message"
                      />,
                    ]}
                  >
                    <div
                      className=""
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="left">
                        <h4>{item.Liturgical_Season}</h4>
                      </div>
                    </div>

                    <div
                      className="py-2"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="my-2">
                        <h4 style={{ color: "#d9001b" }}>
                          {item.First_Reading_Title}
                        </h4>
                      </div>
                      <figure>
                        <blockquote className="blockquote">
                          <p>{item.First_Reading_Italics}</p>
                        </blockquote>
                      </figure>

                      <div
                        className="text-dark"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          backgroundColor: "#fff",

                          borderRadius: "5px",
                        }}
                      >
                        <div className="py-2" style={{ color: "#d9001b" }}>
                          {item.First_Reading_One}{" "}
                          {item.First_Reading_Scripture_Quote}
                        </div>
                        <div className="py-2">
                          {item.First_Reading_Scripture_Body.slice(
                            0,
                            item.First_Reading_Scripture_Body.length - 23
                          )}
                        </div>
                        <div>
                          {item.First_Reading_Scripture_Body.slice(-23)}
                        </div>
                      </div>

                      <div
                        className="py-2"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          backgroundColor: "#fff",
                          borderRadius: "5px",
                        }}
                      >
                        <div
                          className="py-2"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            backgroundColor: "#fff",
                            borderRadius: "5px",
                            gap: 5,
                          }}
                        >
                          <div style={{ color: "#d9001b" }}>
                            {item.Response_Title}
                          </div>
                          <div style={{ color: "#d9001b" }}>
                            {item.Response_Source_Book} {item.Response_Quote}
                          </div>
                        </div>

                        <Container>
                          <div className="py-2">
                            <span
                              style={{ color: "#d9001b", fontWeight: "bolder" }}
                            >
                              R.
                            </span>{" "}
                            {item.Response}
                          </div>

                          {addNextLine(item.Response_Body).map((line, id) => (
                            <div
                              key={id}
                              className=" py-2 list-unstyled w-sm-100"
                              style={{ maxWidth: 30 + `rem` }}
                            >
                              {line.slice(0, line.length - 2)}{" "}
                              <span
                                style={{
                                  color: "#d9001b",
                                  fontWeight: "bolder",
                                }}
                              >
                                {line[line.length - 2]}.
                              </span>
                            </div>
                          ))}
                        </Container>
                      </div>
                    </div>
                    {item.Second_Reading_Title &&
                    item.Second_Reading_Title.length > 0 ? (
                      <>
                        <div className="my-2">
                          <h4 style={{ color: "#d9001b" }}>
                            {item.Second_Reading_Title}
                          </h4>
                        </div>

                        <div
                          className="py-2"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            backgroundColor: "#fff",
                            borderRadius: "5px",
                          }}
                        >
                          <div
                            className=""
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              backgroundColor: "#fff",
                              borderRadius: "5px",
                            }}
                          ></div>

                          <figure>
                            <blockquote className="blockquote">
                              <p>{item.Second_Reading_Italics}</p>
                            </blockquote>
                          </figure>

                          <div
                            className="text-dark"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              backgroundColor: "#fff",
                              borderRadius: "5px",
                            }}
                          >
                            <div className="" style={{ color: "#d9001b" }}>
                              {item.Second_Reading_One}{" "}
                              {item.Second_Reading_Scripture_Quote}
                            </div>
                            <div className="">
                              {item.Second_Reading_Scripture_Body.slice(
                                0,
                                item.Second_Reading_Scripture_Body.length - 23
                              )}
                            </div>
                            <div>
                              {item.Second_Reading_Scripture_Body.slice(-23)}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : null}

                    <div
                      className="py-2"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                      }}
                    >
                      <div
                        className="py-2"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          backgroundColor: "#fff",
                          borderRadius: "5px",
                        }}
                      >
                        <div style={{ color: "#d9001b" }}>
                          {item.Alleluia_Title}
                        </div>
                      </div>
                    </div>
                    <figure>
                      <blockquote className="blockquote">
                        <p>{item.Alleluia_Body}</p>
                      </blockquote>
                      <figcaption className="blockquote-footer">
                        <cite title="Source Title" style={{ color: "#d9001b" }}>
                          {item.Alleluia_Source_Book} {item.Alleluia_Quote}
                        </cite>
                      </figcaption>
                    </figure>
                    <div>
                      <h4 style={{ color: "#d9001b" }}>{item.Gospel_Title}</h4>
                    </div>
                    <div
                      className=""
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                      }}
                    >
                      <div
                        className=""
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          backgroundColor: "#fff",
                          borderRadius: "5px",
                        }}
                      ></div>

                      <figure>
                        <blockquote className="blockquote">
                          <p>{item.Gospel_Italics}</p>
                        </blockquote>
                      </figure>
                    </div>

                    <div
                      className="text-dark"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="py-2" style={{ color: "#d9001b" }}>
                        {item.Gospel_Reading_One} {item.Gospel_Quote}
                      </div>
                      <div className="py-2">
                        {item.Gospel_Body.slice(
                          0,
                          item.Gospel_Body.length - 23
                        )}
                      </div>
                      <div>{item.Gospel_Body.slice(-23)}</div>
                    </div>

                    <div
                      className="py-2 text-dark"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="py-2">
                        <h4 style={{ color: "#d9001b" }}>Reflection</h4>
                      </div>
                      <div className="py-2">{item.Reflection}</div>
                    </div>
                  </List.Item>
                )}
              />
            </div>
          </Col>

          <Col span={8} xs={24} md={8} style={{}}>
            {/* {cardImages.map(({ src, alt }) => ( */}
            {
              <Card style={{ position: "sticky", top: "6rem" }}>
                <CardImg
                  src={`${getReflectionImage(readings).replace(
                    "media",
                    "static"
                  )}`}
                  alt=""
                  style={{ position: "relative" }}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 5,
                    justifyContent: "flex-start",
                    position: "absolute",
                    bottom: 0,
                    padding: "0.3rem",
                  }}
                >
                  <FacebookShareButton
                    title="Daily refelction"
                    quote="Daily refelction"
                    hashtag="Daily refelction"
                    url={`${getReflectionImage(readings).replace(
                      "media",
                      "static"
                    )}`}
                  >
                    <FacebookIcon size={32} round={true} />
                  </FacebookShareButton>
                  <TwitterShareButton
                    title="Daily refelction"
                    quote="Daily refelction"
                    hashtag="Daily refelction"
                    url={`${getReflectionImage(readings).replace(
                      "media",
                      "static"
                    )}`}
                  >
                    <TwitterIcon size={32} round={true} />
                  </TwitterShareButton>
                  <WhatsappShareButton
                    title="Daily refelction"
                    quote="Daily refelction"
                    hashtag="Daily refelction"
                    url={`${getReflectionImage(readings).replace(
                      "media",
                      "static"
                    )}`}
                  >
                    <WhatsappIcon size={32} round={true} />
                  </WhatsappShareButton>
                </div>
              </Card>
            }
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default Readings;
